import React, { useEffect, useState } from 'react';
import styles from './InputImage.module.scss';

export default function InputImage({
  id,
  defaultValue,
  disabled,
  handleChangeImage,
  handleDelete,
  placeholder,
  accept = 'image/*',
  allowPdf = false,
}) {
  const [imageSrc, setImageSrc] = useState(defaultValue || null);
  const [fileLabel, setFileLabel] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    setImageSrc(defaultValue || null);
    setFileLabel('');
  }, [defaultValue]);

  const isPdfUrl = (src) => typeof src === 'string' && src.toLowerCase().includes('.pdf');
  const hasPreview = Boolean(imageSrc || fileLabel);

  const handlePickedFile = (file) => {
    if (!file) return;
    if (file.size > 1 * 1024 * 1024) {
      setError('Fichier trop lourd (max. 1 Mo).');
      return;
    }
    setError('');

    if (allowPdf && file.type === 'application/pdf') {
      setFileLabel(file.name);
      setImageSrc(null);
    } else {
      setFileLabel('');
      const reader = new FileReader();
      reader.onload = () => setImageSrc(reader.result);
      reader.readAsDataURL(file);
    }
    if (handleChangeImage) handleChangeImage(file);
  };

  const handleFileChange = (e) => {
    handlePickedFile(e.target.files?.[0]);
  };

  const handleDeleteClick = () => {
    setImageSrc(null);
    setFileLabel('');
    if (handleDelete) handleDelete();
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handlePickedFile(e.dataTransfer.files?.[0]);
  };

  const inputId = id || 'fileInput';

  const renderPreview = () => {
    if (allowPdf && imageSrc && isPdfUrl(imageSrc)) {
      return (
        <p className={styles.fileLink}>
          <a href={imageSrc} target="_blank" rel="noopener noreferrer">Voir le fichier PDF</a>
        </p>
      );
    }
    if (allowPdf && fileLabel) {
      return <p className={styles.fileLabel}>Fichier : {fileLabel}</p>;
    }
    if (imageSrc) {
      return (
        <div className={styles.imageContainer}>
          <img src={imageSrc} alt="Uploaded" />
        </div>
      );
    }
    return <p dangerouslySetInnerHTML={{ __html: placeholder }} />;
  };

  return (
    <div className={styles.inputFileContainer}>
      <input
        type="file"
        accept={accept}
        onChange={handleFileChange}
        id={inputId}
        disabled={disabled}
        className={styles.inputFile}
      />
      <label htmlFor={inputId}>
        <div
          className={`${styles.dropZone} ${hasPreview ? styles.hasImage : ''} ${disabled ? styles.disabled : ''}`}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
        >
          {renderPreview()}
        </div>
      </label>
      <div className={styles.info}>
        {error && (
          <p className={styles.error}>{error}</p>
        )}
        {(!disabled && hasPreview) && (
          <label htmlFor={inputId}>
            {allowPdf && (fileLabel || (imageSrc && isPdfUrl(imageSrc))) ? 'Changer le fichier' : 'Changer l\'image'}
          </label>
        )}
        {(hasPreview && !disabled) && (
          <p className={styles.delete} onClick={handleDeleteClick}>
            {allowPdf && (fileLabel || (imageSrc && isPdfUrl(imageSrc))) ? 'Supprimer le fichier' : 'Supprimer l\'image'}
          </p>
        )}
      </div>
    </div>
  );
}

